export default "__VITE_ASSET__CTAv3MG5__"